import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
} from '@backstage/core-plugin-api';

// The deploy-v3 API is not registered here. The deploy-v3 plugin registers it
// itself (plugins/deploy-v3/src/plugin.ts), and the New Frontend System
// collects every plugin's API factories before any page renders. Registering
// it here as well would give the same API two owners, 'app' and 'deploy-v3',
// which the app reports as API_FACTORY_CONFLICT and answers with the
// "App startup failed" page after sign-in.
export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
];
